import styled, { css } from 'styled-components';
import media from 'styled-media-query';

// INTERFACES
import { ICol, IRow } from '../../interfaces/Grid.interface';

const getWidthColumn = (value: any) => {
  return css`
    width: ${(value / 18) * 100}%;
  `;
};

export const ColStyled = styled.div<ICol>`
  float: left;
  display: block;
  min-height: 1px;
  box-sizing: border-box;
  padding: 0 40px;

  ${({ justifyContent }) =>
    justifyContent != null &&
    css`
      display: flex;
      justify-content: ${justifyContent};
    `};

  ${({ overflowy }) =>
    overflowy != null &&
    css`
      overflow-y: auto;
      height: 90vh;
      overflow-y: ${overflowy};
    `};

	${({ paddingLeft }) =>
    paddingLeft != null &&
    css`
      padding-left: ${paddingLeft};
    `};

	${({ paddingRight }) =>
    paddingRight != null &&
    css`
      padding-right: ${paddingRight};
    `};

  ${media.lessThan<ICol>('medium')`
    ${({ sm }) => sm && getWidthColumn(sm)};
  `}

  ${media.between<ICol>('medium', 'large')`
    ${({ md }) => md && getWidthColumn(md)};
  `}

  ${media.greaterThan<ICol>('large')`
    ${({ lg }) => lg && getWidthColumn(lg)};
  `}
`;

export const ContainerStyled = styled.div`
  display: block;
  max-width: 1920px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  &:before,
  &:after {
    content: '';
    display: table;
  }
  &:after {
    clear: both;
  }
`;

export const RowStyled = styled.div<IRow>`
  width: 100%;
  height: auto;
  float: left;
  display: block;
  box-sizing: border-box;

  ${media.lessThan<IRow>('medium')`
    ${({ centralized }) =>
      centralized &&
      css`
        text-align: center;
      `};
  `};

  ${media.greaterThan<IRow>('medium')`
    ${({ centralized }) =>
      centralized &&
      css`
        display: flex;
        align-items: center;
      `};
  `}

  &:before,
  &:after {
    content: '';
    display: table;
  }
  &:after {
    clear: both;
  }
`;
